import type { ProgramDetailsPageData } from '@educator/components/ProgramSections/types/sections'

export const programDetailsPageData: ProgramDetailsPageData = {
  sections: [
    {
      id: 'hero',
      type: 'hero',
      data: {
        titleKey: 'hero.title',
        descriptionKey: 'hero.description',
        video: {
          desktopUuid: '0fd3afa1-058a-43fe-8790-3dd4d8e97219',
          mobileUuid: 'b739020a-81bb-4b88-b56f-533b667bc308',
        },
        details: [
          {
            labelKey: 'hero.details.earlyApplicationDue.label',
            valueKey: 'hero.details.earlyApplicationDue.value',
            kind: 'cohort',
          },
          {
            labelKey: 'hero.details.startDate.label',
            valueKey: 'hero.details.startDate.value',
            kind: 'startDate',
          },
          {
            labelKey: 'hero.details.liveEvents.label',
            valueKey: 'hero.details.liveEvents.value',
          },
          {
            labelKey: 'hero.details.selectiveCommunity.label',
            valueKey: 'hero.details.selectiveCommunity.value',
          },
          {
            labelKey: 'hero.details.timeCommitment.label',
            valueKey: 'hero.details.timeCommitment.value',
          },
        ],
      },
    },
    {
      id: 'value-promise',
      type: 'valuePromise',
    },
    {
      id: 'testimonials',
      type: 'testimonials',
      data: {
        itemsKey: 'testimonials.items',
      },
    },
    {
      id: 'ai-labs',
      type: 'aiLabs',
      data: {
        itemsKey: 'aiLabs.items',
        partnersKey: 'aiLabs.partnersHeadline',
      },
    },
    {
      id: 'instructors',
      type: 'instructors',
      data: {
        itemsKey: 'instructors.items',
      },
    },
    {
      id: 'curriculum',
      type: 'curriculum',
      data: {
        itemsKey: 'curriculum.items',
      },
    },
    {
      id: 'previous-cohort',
      type: 'previousCohort',
    },
    {
      id: 'cta',
      type: 'cta',
      data: {
        headlineKey: 'cta.headline',
        cohortHeadlineKey: 'cta.headlineWithCohort',
      },
    },
    {
      id: 'admissions',
      type: 'admissions',
    },
    {
      id: 'faq',
      type: 'faq',
    },
  ],
}
